import { api } from "./client";
import type { Translation } from "./menu";

export interface Station {
  id: number;
  slug: string;
  color: string;
  sortIndex: number;
  translations: Translation[];
}

export const getStations = async (): Promise<Station[]> => {
  const response = await api.get<Station[]>("/menu/stations");
  return response.data;
};

// Езици на организацията (org DB `languages`) — за избор на език на печат при
// POS принтер в „Устройства".
export interface Language {
  id: number;
  code: string;
  isDefault: boolean;
}

export const getLanguages = async (): Promise<Language[]> => {
  const response = await api.get<Language[]>("/menu/languages");
  return response.data;
};
